var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRosatom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 183.82 64.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:#1a1a1a;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 947.48,
    cy: 713.96,
    r: 30.67,
    gradientTransform: "matrix(0.31, 0, 0, 0.31, -263.29, -193.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4495d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15256d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 699.56,
    y1: -383.36,
    x2: 727.78,
    y2: -395.38,
    gradientTransform: "translate(-742.47 -221.41) rotate(45)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 634.9,
    y1: 1130.19,
    x2: 663.12,
    y2: 1118.18,
    gradientTransform: "translate(-1245.1 375.83) rotate(-75)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -755.79,
    y1: 250.84,
    x2: -727.57,
    y2: 238.82,
    gradientTransform: "translate(-602.14 477.27) rotate(165)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 11.88,
    y1: 23.95,
    x2: 24.67,
    y2: 4.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 36.08,
    y1: 51.93,
    x2: 13.14,
    y2: 54.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 50.85,
    y1: 18.75,
    x2: 55.52,
    y2: 42.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.56,36.88a6.77,6.77,0,1,1-.48-9.57A6.76,6.76,0,0,1,37.56,36.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.31,9.14c.56.56,1.09,1.13,1.56,1.7a26.62,26.62,0,0,1,4,6.46,21.33,21.33,0,0,0,4.87.34l.29,0,.26,0A18.56,18.56,0,0,0,57,12l.41-.42c-.62-.74-1.25-1.46-1.94-2.15a32.38,32.38,0,0,0-42.24-3C23.13,1.61,30,4.93,34.31,9.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.39,42c.2-.77.43-1.51.68-2.2a26.85,26.85,0,0,1,3.6-6.69,21,21,0,0,0-2.14-4.38l-.16-.25-.15-.21A18.54,18.54,0,0,0,2.57,21L2,20.83c-.33.9-.63,1.81-.89,2.75A32.38,32.38,0,0,0,19.6,61.67C10.45,55.47,9.88,47.83,11.39,42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M51.4,45.47c-.77.21-1.53.38-2.26.51a26.74,26.74,0,0,1-7.59.22,21,21,0,0,0-2.72,4c0,.09-.09.17-.13.26a2.56,2.56,0,0,0-.11.24,18.49,18.49,0,0,0-1,12.88c0,.19.11.38.17.57.94-.17,1.89-.35,2.83-.6A32.4,32.4,0,0,0,64.31,28.53C63.51,39.56,57.18,43.86,51.4,45.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M13.18,6.43A30.63,30.63,0,0,0,2.49,19.66a19.33,19.33,0,0,1,14.41,13c.89-.57,3.63-2.74,5.47-8.7,2.23-7.21,6.45-12.53,11.94-14.85C34.31,9.14,27.36-.75,13.18,6.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M35.44,58.34a19.29,19.29,0,0,1,5.07-13.05l.05-.07c-.67-.71-3-2.45-9-1.09C24.25,45.8,16.13,45.61,11.39,42c0,0-5.1,11,8.21,19.65a30.58,30.58,0,0,0,16.78,2.65A18.45,18.45,0,0,1,35.44,58.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M58.2,12.66a19.12,19.12,0,0,1-14.32,6.49,21,21,0,0,1-4.25-.45h-.07c-.28,1-.5,3.85,3.55,8.21,5.13,5.54,9,12.66,8.29,18.57,0,0,12-1.07,12.91-16.94A30.62,30.62,0,0,0,58.2,12.66Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.24,40.54H75.87V24.83h5.41c4,0,6.44,1.64,6.44,5.25S85.16,35.63,81,35.63H79.24Zm-.07-7.88H81c2,0,3.23-.78,3.23-2.44S83.1,27.8,81,27.8H79.17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M90.17,32.69c0-5.28,3.21-8.13,7.54-8.13,4.85,0,7.66,3.08,7.66,8.13,0,5.59-3.26,8.12-7.57,8.12C93.25,40.81,90.17,38,90.17,32.69Zm11.63,0c0-3.57-1.64-5.16-4.09-5.16-2.22,0-4,1.66-4,5.16s1.82,5.16,4.18,5.16S101.8,36.21,101.8,32.69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M120.35,39.91a8.33,8.33,0,0,1-4.25.9c-4.8,0-8-2.76-8-7.92,0-5.41,3.16-8.33,8.3-8.33a9.94,9.94,0,0,1,4,.74l-.74,2.83a9.6,9.6,0,0,0-2.74-.47c-3.1,0-5.21,1.55-5.21,5,0,3.32,2,5,5.19,5a7.93,7.93,0,0,0,2.78-.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M132.67,36.35H126l-1.52,4.19h-2l6-15.71h2l5.88,15.71h-2.11Zm-6.06-1.84H132l-2.62-7.39h-.09Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M143.3,40.54h-2V26.72h-4.65V24.83h11.31v1.89H143.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M150.08,32.69c0-5,2.9-8.08,7-8.08,4.67,0,7.18,3.32,7.18,8.08,0,5.34-3,8.08-7.11,8.08C152.84,40.77,150.08,37.67,150.08,32.69Zm12.08,0c0-4.31-1.93-6.2-5-6.2-2.76,0-4.89,2-4.89,6.2s2.06,6.19,5.16,6.19C160.34,38.88,162.16,36.75,162.16,32.69Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M183.82,40.54h-2l-1-12.27-4,12.27h-2.11l-3.94-12.23-1,12.23h-2l1.34-15.71h2.47l4.24,13.51L180,24.83h2.47Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosatom);
export default __webpack_public_path__ + "static/media/rosatom.f19192890577cee7bbed9e5b855a1b55.svg";
export { ForwardRef as ReactComponent };